export const comments_5689019 = {"data":{"data":[],"links":{}}}